import { httpGet, httpPost } from "../Web"
import { ApiResponse } from "./ApiResponse"

export interface WorkshopUser {
    id?: number,
    guid?: string | null,
    companyName?: string,
    companyId?: number,
    accessLevel?: UserAccessLevel,
    userStatus?: UserStatus,
    name?: string,
    eMail?: string,
    isWorkshopAdmin: boolean,

    departureTime?: string | null,
    arrivalTime?: string | null,
    hotel?: string | null,
    comment?: string | null,
    status?: WorkshopUserStatus,
    workshopId: number,
    userId: number
};

export enum UserAccessLevel {
    Guest = 0, Tester = 1, Administrator = 2
}

export enum WorkshopUserStatus {
    Registered = 1, Paid = 2
};

export const WorkshopUserStatusStrings = ["", "Registered", "Paid"];

export enum UserStatus {
    Unknown = 0, Active = 1, Disabled = 2
};

export const getWorkshopUsers = (wsId: number, abortController: AbortController): Promise<ApiResponse<WorkshopUser[]>> => {
    return httpGet(`/api/workshop/user/${wsId}`, abortController);
} 

export const updateWorkshopUser = (data: WorkshopUser, abortController: AbortController): Promise<ApiResponse<WorkshopUser>> =>
    httpPost(`/api/workshop/user/update`, data, abortController);

export const deleteWorkshopUser = (wsUserId: number, abortController: AbortController): Promise<ApiResponse<WorkshopUser>> => {
    return httpGet(`/api/workshop/user/delete/${wsUserId}`, abortController);
} 